// // import { useEffect, useState } from "react";
// // import axios from "axios";
// // import RoomCard from "../components/RoomCard";
// // import "./HomePage.css";

// // export default function HomePage() {
// //   const [rooms, setRooms] = useState([]);
// //   const [searchQuery, setSearchQuery] = useState("");
// //   const [category, setCategory] = useState("all");
// //   const [maxPrice, setMaxPrice] = useState("");
// //   const [currentPage, setCurrentPage] = useState(1);

// //   const roomsPerPage = 6;

// //   // -------------------------------
// //   // LOAD ROOMS FROM BACKEND
// //   // -------------------------------
// //   useEffect(() => {
// //     axios
// //       .get("http://localhost:8080/api/rooms")
// //       .then((res) => {
// //         console.log("Rooms from backend:", res.data);
// //         setRooms(res.data);
// //       })
// //       .catch((err) => console.error("Error loading rooms:", err));
// //   }, []);

// //   // FILTER LOGIC
// //   const filteredRooms = rooms.filter((room) => {
// //     const matchesSearch =
// //       room.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
// //       room.description.toLowerCase().includes(searchQuery.toLowerCase());

// //     const matchesCategory =
// //       category === "all" ? true : room.roomType === category;

// //     const matchesPrice =
// //       maxPrice === "" ? true : Number(room.price) <= Number(maxPrice);

// //     return matchesSearch && matchesCategory && matchesPrice;
// //   });

// //   // PAGINATION
// //   const indexOfLastRoom = currentPage * roomsPerPage;
// //   const indexOfFirstRoom = indexOfLastRoom - roomsPerPage;

// //   const currentRooms = filteredRooms.slice(indexOfFirstRoom, indexOfLastRoom);

// //   const totalPages = Math.ceil(filteredRooms.length / roomsPerPage);

// //   return (
// //     <div className="home-container">
// //       <h1 className="home-title">Available Rooms</h1>

// //       {/* FILTERS */}
// //       <div className="filter-bar">
// //         <input
// //           type="text"
// //           placeholder="Search rooms..."
// //           className="filter-input"
// //           value={searchQuery}
// //           onChange={(e) => setSearchQuery(e.target.value)}
// //         />

// //         <select
// //           className="filter-select"
// //           value={category}
// //           onChange={(e) => setCategory(e.target.value)}
// //         >
// //           <option value="all">All</option>
// //           <option value="AC">AC</option>
// //           <option value="Non-AC">Non-AC</option>
// //           <option value="Deluxe">Deluxe</option>
// //           <option value="Luxury">Luxury</option>
// //         </select>

// //         <input
// //           type="number"
// //           placeholder="Max Price"
// //           className="filter-input"
// //           value={maxPrice}
// //           onChange={(e) => setMaxPrice(e.target.value)}
// //         />
// //       </div>

// //       {/* ROOM GRID */}
// //       <div className="room-grid">
// //         {currentRooms.length > 0 ? (
// //           currentRooms.map((room) => <RoomCard key={room.id} room={room} />)
// //         ) : (
// //           <p className="no-rooms">No rooms found.</p>
// //         )}
// //       </div>

// //       {/* PAGINATION */}
// //       {totalPages > 1 && (
// //         <div className="pagination-container">
// //           {[...Array(totalPages)].map((_, index) => (
// //             <button
// //               key={index}
// //               onClick={() => setCurrentPage(index + 1)}
// //               className={`pagination-btn ${
// //                 currentPage === index + 1 ? "active-page" : ""
// //               }`}
// //             >
// //               {index + 1}
// //             </button>
// //           ))}
// //         </div>
// //       )}
// //     </div>
// //   );
// // }
  
//    //UI Bootstrap Code//
// //  import { useEffect, useState } from "react";
// // import axios from "axios";
// // import RoomCard from "../components/RoomCard";

// // export default function HomePage() {
// //   const [rooms, setRooms] = useState([]);
// //   const [searchQuery, setSearchQuery] = useState("");
// //   const [category, setCategory] = useState("all");
// //   const [maxPrice, setMaxPrice] = useState("");
// //   const [currentPage, setCurrentPage] = useState(1);

// //   const roomsPerPage = 6;

// //   useEffect(() => {
// //     axios
// //       .get("http://localhost:8080/api/rooms")
// //       .then((res) => setRooms(res.data))
// //       .catch((err) => console.error("Error loading rooms:", err));
// //   }, []);

// //   // FILTERING
// //   const filteredRooms = rooms.filter((room) => {
// //     const matchesSearch =
// //       room.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
// //       room.description.toLowerCase().includes(searchQuery.toLowerCase());

// //     const matchesCategory = category === "all" ? true : room.roomType === category;
// //     const matchesPrice = maxPrice === "" ? true : Number(room.price) <= Number(maxPrice);

// //     return matchesSearch && matchesCategory && matchesPrice;
// //   });

// //   // PAGINATION LOGIC
// //   const indexOfLastRoom = currentPage * roomsPerPage;
// //   const indexOfFirstRoom = indexOfLastRoom - roomsPerPage;
// //   const currentRooms = filteredRooms.slice(indexOfFirstRoom, indexOfLastRoom);
// //   const totalPages = Math.ceil(filteredRooms.length / roomsPerPage);

// //   return (
// //     <div className="container mt-4">

// //       {/* ------------------------ HEADER ------------------------ */}
// //       <div className="text-center mb-4">
// //         <h1 className="fw-bold">🏨 Explore Our Rooms</h1>
// //         <p className="text-muted">Find the best room that fits your comfort</p>
// //       </div>




// //       {/* ------------------------ FILTERS ------------------------ */}
// //       <div className="card shadow-sm p-3 mb-4">
// //         <div className="row g-3">

// //           <div className="col-md-4">
// //             <input
// //               type="text"
// //               className="form-control"
// //               placeholder="Search rooms..."
// //               value={searchQuery}
// //               onChange={(e) => setSearchQuery(e.target.value)}
// //             />
// //           </div>

// //           <div className="col-md-4">
// //             <select
// //               className="form-select"
// //               value={category}
// //               onChange={(e) => setCategory(e.target.value)}
// //             >
// //               <option value="all">All</option>
// //               <option value="AC">AC</option>
// //               <option value="Non-AC">Non-AC</option>
// //               <option value="Deluxe">Deluxe</option>
// //               <option value="Luxury">Luxury</option>
// //             </select>
// //           </div>

// //           <div className="col-md-4">
// //             <input
// //               type="number"
// //               className="form-control"
// //               placeholder="Max Price"
// //               value={maxPrice}
// //               onChange={(e) => setMaxPrice(e.target.value)}
// //             />
// //           </div>

// //         </div>
// //       </div>

// //       {/* ------------------------ ROOM GRID ------------------------ */}
// //       <div className="row">
// //         {currentRooms.length > 0 ? (
// //           currentRooms.map((room) => <RoomCard key={room.id} room={room} />)
// //         ) : (
// //           <div className="alert alert-warning text-center">
// //             No rooms found.
// //           </div>
// //         )}
// //       </div>

// //       {/* ------------------------ PAGINATION ------------------------ */}
// //       {totalPages > 1 && (
// //         <nav className="mt-4 d-flex justify-content-center">
// //           <ul className="pagination">
// //             {[...Array(totalPages)].map((_, index) => (
// //               <li
// //                 key={index}
// //                 className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
// //               >
// //                 <button
// //                   onClick={() => setCurrentPage(index + 1)}
// //                   className="page-link"
// //                 >
// //                   {index + 1}
// //                 </button>
// //               </li>
// //             ))}
// //           </ul>
// //         </nav>
// //       )}
// //     </div>
// //   );
// // }

// // Working code with Bootstrap UI //

// // import { useEffect, useState } from "react";
// // import axios from "axios";
// // import RoomCard from "../components/RoomCard";

// // export default function HomePage() {
// //   const [rooms, setRooms] = useState([]);
// //   const [searchQuery, setSearchQuery] = useState("");
// //   const [category, setCategory] = useState("all");
// //   const [maxPrice, setMaxPrice] = useState("");
// //   const [currentPage, setCurrentPage] = useState(1);

// //   const roomsPerPage = 6;

// //   useEffect(() => {
// //     axios
// //       .get("http://localhost:8080/api/rooms")
// //       .then((res) => setRooms(res.data))
// //       .catch((err) => console.error("Error loading rooms:", err));
// //   }, []);

// //   // FILTERING
// //   const filteredRooms = rooms.filter((room) => {
// //     const matchesSearch =
// //       room.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
// //       room.description.toLowerCase().includes(searchQuery.toLowerCase());

// //     const matchesCategory =
// //       category === "all" ? true : room.roomType === category;

// //     const matchesPrice =
// //       maxPrice === "" ? true : Number(room.price) <= Number(maxPrice);

// //     return matchesSearch && matchesCategory && matchesPrice;
// //   });

// //   // PAGINATION LOGIC
// //   const indexOfLastRoom = currentPage * roomsPerPage;
// //   const indexOfFirstRoom = indexOfLastRoom - roomsPerPage;
// //   const currentRooms = filteredRooms.slice(indexOfFirstRoom, indexOfLastRoom);
// //   const totalPages = Math.ceil(filteredRooms.length / roomsPerPage);

// //   return (
// //     <div>
// //       {/* ------------------------ HERO SECTION ------------------------ */}
// //       <div
// //         className="hero-section d-flex align-items-center justify-content-center"
// //         style={{
// //           // backgroundImage:
// //           //   "url('https://images.unsplash.com/photo-1501117716987-c8e1ecb210c7')",
// //              backgroundImage: "url('/rooms/hero1.jpg')",
// //           backgroundSize: "cover",
// //           backgroundPosition: "center",
// //           height: "60vh",
// //           position: "relative",
// //         }}
// //       >
// //         {/* Dark overlay */}
// //         <div
// //           style={{
// //             inset: 0,
// //             position: "absolute",
// //             background: "rgba(0,0,0,0.45)",
// //           }}
// //         />

// //         {/* Search Box */}
// //         <div
// //           className="container position-relative"
// //           style={{ zIndex: 2, maxWidth: "900px" }}
// //         >
// //           <h1 className="text-white text-center fw-bold mb-4">
// //             Find the Perfect Room for Your Stay
// //           </h1>

// //           <div className="card p-4 shadow-lg">
// //             <div className="row g-3">
// //               <div className="col-md-3">
// //                 <label className="form-label fw-semibold">Check-In</label>
// //                 <input type="date" className="form-control" />
// //               </div>

// //               <div className="col-md-3">
// //                 <label className="form-label fw-semibold">Check-Out</label>
// //                 <input type="date" className="form-control" />
// //               </div>

// //               <div className="col-md-3">
// //                 <label className="form-label fw-semibold">Guests</label>
// //                 <select className="form-select">
// //                   <option>1 Guest</option>
// //                   <option>2 Guests</option>
// //                   <option>3 Guests</option>
// //                   <option>4 Guests</option>
// //                   <option>5+ Guests</option>
// //                 </select>
// //               </div>

// //               <div className="col-md-3 d-flex align-items-end">
// //                 <button className="btn btn-primary w-100 fw-bold">
// //                   Search Rooms
// //                 </button>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* ------------------------ MAIN CONTENT ------------------------ */}
// //       <div className="container mt-5">
// //         <div className="text-center mb-4">
// //           <h1 className="fw-bold">🏨 Explore Our Rooms</h1>
// //           <p className="text-muted">Find the best room that fits your comfort</p>
// //         </div>

// //         {/* FILTERS */}
// //         <div className="card shadow-sm p-3 mb-4">
// //           <div className="row g-3">
// //             <div className="col-md-4">
// //               <input
// //                 type="text"
// //                 className="form-control"
// //                 placeholder="Search rooms..."
// //                 value={searchQuery}
// //                 onChange={(e) => setSearchQuery(e.target.value)}
// //               />
// //             </div>

// //             <div className="col-md-4">
// //               <select
// //                 className="form-select"
// //                 value={category}
// //                 onChange={(e) => setCategory(e.target.value)}
// //               >
// //                 <option value="all">All</option>
// //                 <option value="AC">AC</option>
// //                 <option value="Non-AC">Non-AC</option>
// //                 <option value="Deluxe">Deluxe</option>
// //                 <option value="Luxury">Luxury</option>
// //               </select>
// //             </div>

// //             <div className="col-md-4">
// //               <input
// //                 type="number"
// //                 className="form-control"
// //                 placeholder="Max Price"
// //                 value={maxPrice}
// //                 onChange={(e) => setMaxPrice(e.target.value)}
// //               />
// //             </div>
// //           </div>
// //         </div>

// //         {/* ROOM GRID */}
// //         <div className="row">
// //           {currentRooms.length > 0 ? (
// //             currentRooms.map((room) => (
// //               <RoomCard key={room.id} room={room} />
// //             ))
// //           ) : (
// //             <div className="alert alert-warning text-center">
// //               No rooms found.
// //             </div>
// //           )}
// //         </div>

// //         {/* PAGINATION */}
// //         {totalPages > 1 && (
// //           <nav className="mt-4 d-flex justify-content-center">
// //             <ul className="pagination">
// //               {[...Array(totalPages)].map((_, index) => (
// //                 <li
// //                   key={index}
// //                   className={`page-item ${
// //                     currentPage === index + 1 ? "active" : ""
// //                   }`}
// //                 >
// //                   <button
// //                     onClick={() => setCurrentPage(index + 1)}
// //                     className="page-link"
// //                   >
// //                     {index + 1}
// //                   </button>
// //                 </li>
// //               ))}
// //             </ul>
// //           </nav>
// //         )}
// //       </div>
// //     </div>
// //   );
// // }


// // With HotelReview Code //

// // import { useEffect, useState } from "react";
// // import axios from "axios";
// // import RoomCard from "../components/RoomCard";
// // import HotelReview from "../components/HotelReview"; // New component import
// // import ContactSection from "../components/ContactSection";


// // export default function HomePage() {
// //   const [rooms, setRooms] = useState([]);
// //   const [searchQuery, setSearchQuery] = useState("");
// //   const [category, setCategory] = useState("all");
// //   const [maxPrice, setMaxPrice] = useState("");
// //   const [currentPage, setCurrentPage] = useState(1);

// //   const roomsPerPage = 6;

// //   useEffect(() => {
// //     axios
// //       .get("http://localhost:8080/api/rooms")
// //       .then((res) => setRooms(res.data))
// //       .catch((err) => console.error("Error loading rooms:", err));
// //   }, []);

// //   // FILTERING
// //   const filteredRooms = rooms.filter((room) => {
// //     const matchesSearch =
// //       room.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
// //       room.description.toLowerCase().includes(searchQuery.toLowerCase());

// //     const matchesCategory =
// //       category === "all" ? true : room.roomType === category;

// //     const matchesPrice =
// //       maxPrice === "" ? true : Number(room.price) <= Number(maxPrice);

// //     return matchesSearch && matchesCategory && matchesPrice;
// //   });

// //   // PAGINATION LOGIC
// //   const indexOfLastRoom = currentPage * roomsPerPage;
// //   const indexOfFirstRoom = indexOfLastRoom - roomsPerPage;
// //   const currentRooms = filteredRooms.slice(indexOfFirstRoom, indexOfLastRoom);
// //   const totalPages = Math.ceil(filteredRooms.length / roomsPerPage);

// //   return (
// //     <div>
// //       {/* ------------------------ HERO SECTION ------------------------ */}
// //       <div
// //         className="hero-section d-flex align-items-center justify-content-center"
// //         style={{
// //           backgroundImage: "url('/rooms/hero1.jpg')",
// //           backgroundSize: "cover",
// //           backgroundPosition: "center",
// //           height: "60vh",
// //           position: "relative",
// //         }}
// //       >
// //         <div
// //           style={{
// //             inset: 0,
// //             position: "absolute",
// //             background: "rgba(0,0,0,0.45)",
// //           }}
// //         />
// //         <div
// //           className="container position-relative"
// //           style={{ zIndex: 2, maxWidth: "900px" }}
// //         >
// //           <h1 className="text-white text-center fw-bold mb-4">
// //             Find the Perfect Room for Your Stay
// //           </h1>

// //           <div className="card p-4 shadow-lg">
// //             <div className="row g-3">
// //               <div className="col-md-3">
// //                 <label className="form-label fw-semibold">Check-In</label>
// //                 <input type="date" className="form-control" />
// //               </div>
// //               <div className="col-md-3">
// //                 <label className="form-label fw-semibold">Check-Out</label>
// //                 <input type="date" className="form-control" />
// //               </div>
// //               <div className="col-md-3">
// //                 <label className="form-label fw-semibold">Guests</label>
// //                 <select className="form-select">
// //                   <option>1 Guest</option>
// //                   <option>2 Guests</option>
// //                   <option>3 Guests</option>
// //                   <option>4 Guests</option>
// //                   <option>5+ Guests</option>
// //                 </select>
// //               </div>
// //               <div className="col-md-3 d-flex align-items-end">
// //                 <button className="btn btn-primary w-100 fw-bold">
// //                   Search Rooms
// //                 </button>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* ------------------------ MAIN CONTENT ------------------------ */}
// //       <div className="container mt-5">
// //         <div className="text-center mb-4">
// //           <h1 className="fw-bold">🏨 Explore Our Rooms</h1>
// //           <p className="text-muted">Find the best room that fits your comfort</p>
// //         </div>

// //         {/* FILTERS */}
// //         <div className="card shadow-sm p-3 mb-4">
// //           <div className="row g-3">
// //             <div className="col-md-4">
// //               <input
// //                 type="text"
// //                 className="form-control"
// //                 placeholder="Search rooms..."
// //                 value={searchQuery}
// //                 onChange={(e) => setSearchQuery(e.target.value)}
// //               />
// //             </div>
// //             <div className="col-md-4">
// //               <select
// //                 className="form-select"
// //                 value={category}
// //                 onChange={(e) => setCategory(e.target.value)}
// //               >
// //                 <option value="all">All</option>
// //                 <option value="AC">AC</option>
// //                 <option value="Non-AC">Non-AC</option>
// //                 <option value="Deluxe">Deluxe</option>
// //                 <option value="Luxury">Luxury</option>
// //               </select>
// //             </div>
// //             <div className="col-md-4">
// //               <input
// //                 type="number"
// //                 className="form-control"
// //                 placeholder="Max Price"
// //                 value={maxPrice}
// //                 onChange={(e) => setMaxPrice(e.target.value)}
// //               />
// //             </div>
// //           </div>
// //         </div>

// //         {/* ROOM GRID */}
// //         <div className="row">
// //           {currentRooms.length > 0 ? (
// //             currentRooms.map((room) => <RoomCard key={room.id} room={room} />)
// //           ) : (
// //             <div className="alert alert-warning text-center">No rooms found.</div>
// //           )}
// //         </div>

// //         {/* PAGINATION */}
// //         {totalPages > 1 && (
// //           <nav className="mt-4 d-flex justify-content-center">
// //             <ul className="pagination">
// //               {[...Array(totalPages)].map((_, index) => (
// //                 <li
// //                   key={index}
// //                   className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
// //                 >
// //                   <button
// //                     onClick={() => setCurrentPage(index + 1)}
// //                     className="page-link"
// //                   >
// //                     {index + 1}
// //                   </button>
// //                 </li>
// //               ))}
// //             </ul>
// //           </nav>
// //         )}


       


// // {/* ================= ACTIVITIES SECTION ================= */}
// // <section className="bg-gray-100 py-12 mt-12">
// //   <div className="container mx-auto px-4">

// //     <h2 className="text-3xl font-bold text-center mb-10">
// //       🎯 Hotel Activities
// //     </h2>

// //     <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
// //       {[
// //         { img: "/activities/kayaking.jpg", title: "KayaKing" },
// //         { img: "/activities/BonFire.jpg", title: "BonFire With Friends" },
// //         { img: "/activities/camping1.jpg", title: "Camping in Nature" },
// //         { img: "/activities/Barbecue.jpg", title: "Testy Meal" },
// //       ].map((activity, i) => (
// //         <div
// //           key={i}
// //           className="bg-white rounded-2xl shadow-md overflow-hidden
// //                      hover:shadow-xl hover:scale-105 transition-transform duration-300"
// //         >
// //           <img
// //             src={activity.img}
// //             alt={activity.title}
// //             className="w-full h-48 object-cover"
// //           />
// //           <div className="p-4 text-center">
// //             <h4 className="text-lg font-semibold">{activity.title}</h4>
// //           </div>
// //         </div>
// //       ))}
// //     </div>

// //     <div className="text-center mt-8">
// //       <a
// //         href="/activities"
// //         className="inline-block px-8 py-3 bg-indigo-600 text-white rounded-xl
// //                    hover:bg-indigo-700 transition"
// //       >
// //         View All Activities →
// //       </a>
// //     </div>

// //   </div>
// // </section>




// //         {/* ------------------------ HOTEL REVIEW SECTION ------------------------ */}
// //         <div className="mt-5">
// //           {/* <h2 className="text-center fw-bold mb-4">💬 Customer Reviews</h2> */}
// //           <HotelReview /> {/* Horizontal scroll review component */}
// //         </div>

// //         {/* ------------------------ CONTACT US SECTION ------------------------ */}
// // <div className="mt-5">
// //   <ContactSection />
// // </div>

       


// //       </div>
// //     </div>
// //   );
// // }
  

// //***** * Changed to design only on 7/1/26 ****//

// import { useEffect, useState } from "react";
// import axios from "axios";
// import HeroAvailability from "../components/HeroAvailability";
// import RoomCard from "../components/RoomCard";
// //import HotelReview from "../components/HotelReview";
// import ContactSection from "../components/ContactSection";
// import './HomePage.css'; // Make sure to create this CSS file!
// import Activity from "../pages/Activity";
// import Services from "../components/Services";
// import BlogPosts from "../components/BlogPosts";
// import Testimonials from "../components/Testimonials";

// export default function HomePage() {
//   const [rooms, setRooms] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [category, setCategory] = useState("all");
//   const [maxPrice, setMaxPrice] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);

//   const roomsPerPage = 6;

//   useEffect(() => {
//     axios
//       .get("http://localhost:8080/api/rooms")
//       .then((res) => setRooms(res.data))
//       .catch((err) => console.error("Error loading rooms:", err));
//   }, []);

//   // FILTERING LOGIC
//   const filteredRooms = rooms.filter((room) => {
//     const matchesSearch =
//       room.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
//       room.description.toLowerCase().includes(searchQuery.toLowerCase());
//     const matchesCategory = category === "all" ? true : room.roomType === category;
//     const matchesPrice = maxPrice === "" ? true : Number(room.price) <= Number(maxPrice);
//     return matchesSearch && matchesCategory && matchesPrice;
//   });

//   const indexOfLastRoom = currentPage * roomsPerPage;
//   const indexOfFirstRoom = indexOfLastRoom - roomsPerPage;
//   const currentRooms = filteredRooms.slice(indexOfFirstRoom, indexOfLastRoom);
//   const totalPages = Math.ceil(filteredRooms.length / roomsPerPage);

//   return (
//     <div className="homepage-wrapper">
      

      

//     <div className="hero-fresh d-flex align-items-center justify-content-center">
  
//   {/* AVAILABILITY FORM COMPONENT */}
//   <HeroAvailability />

// </div>

  

     

      

//       {/* 4. ABOUT US SECTION  */}
//       <section className="container mt-custom-about py-5">
//         <div className="row align-items-center g-5">
//           <div className="col-lg-6">
//             <h6 className="text-roberto text-uppercase fw-bold mb-3">About Us</h6>
//             <h2 className="display-5 fw-bold mb-4">Welcome To <br/>NIVARA AGRO TOURISM</h2>
//             <p className="text-muted leading-relaxed mb-4">
//               <b>Nivara Agro Tourism </b> was born from a simple yet powerful dream — to create a space where the chaos of city life fades away and the soothing rhythm of nature takes over. Nestled along the scenic riverbanks, Nivara Agro Tourism began its journey as a humble retreat for those seeking solace in the arms of nature. What started as a small passion project has blossomed into one of the most sought-after agro tourism destinations in the region.



// Over the years, we have welcomed thousands of guests — families, solo travelers, couples, and corporate groups — all of whom came looking for something real, something raw, and something refreshing. With every passing season, we have grown not just in size but in our commitment to delivering experiences that stay etched in the hearts of our visitors long after they leave.



// Our story is not just about a place — it is about the moments created here, the laughter shared around a bonfire, the thrill of paddling through the river, and the peace found in watching a golden sunrise from a riverside tent. That is the story of Nivara Agro Tourism, and it is still being written — one unforgettable stay at a time.
//             </p>
//             <div className="manager-info">
//                <p className="mb-0">Owner: <span className="text-roberto">Mangesh Dhanawade</span></p>
//                {/* <img src="/signature.png" alt="signature" style={{ width: '120px', opacity: 0.6 }} /> */}
//             </div>
//           </div>
//           <div className="col-lg-6">
//             <div className="row g-3">
//                 <div className="col-8">
//                     <img src="https://images.unsplash.com/photo-1542314831-068cd1dbfeeb" className="img-fluid rounded shadow" alt="hotel1" />
//                 </div>
//                 <div className="col-4">
//                     <img src="https://images.unsplash.com/photo-1566073771259-6a8506099945" className="img-fluid rounded shadow mb-3" alt="hotel2" />
//                     <img src="https://images.unsplash.com/photo-1520250497591-112f2f40a3f4" className="img-fluid rounded shadow" alt="hotel3" />
//                 </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* 5. MAIN CONTENT (ROOMS) */}
//       <div className="container mt-5 pt-5">
//         <div className="text-center mb-5">
//           {/* <h6 className="text-roberto text-uppercase fw-bold">Our Rooms</h6> */}
//           <h2 className="fw-bold text-success display-6">Explore Our Rooms</h2>
//         </div>

//         {/* SEARCH & FILTERS */}
//         <div className="card shadow-sm p-4 mb-5 border-0 bg-light">
//           <div className="row g-3">
//             <div className="col-md-4">
//               <input type="text" className="form-control" placeholder="Search rooms..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
//             </div>
//             <div className="col-md-4">
//               <select className="form-select" value={category} onChange={(e) => setCategory(e.target.value)}>
//                 <option value="all">All Categories</option>
//                 <option value="AC">AC</option>
//                 <option value="Non-AC">Non-AC</option>
//                 <option value="Deluxe">Deluxe</option>
//                 <option value="Luxury">Luxury</option>
//               </select>
//             </div>
//             <div className="col-md-4">
//               <input type="number" className="form-control" placeholder="Max Price" value={maxPrice} onChange={(e) => setMaxPrice(e.target.value)} />
//             </div>
//           </div>
//         </div>

//         <div className="row">
//           {currentRooms.length > 0 ? (
//             currentRooms.map((room) => <RoomCard key={room.id} room={room} />)
//           ) : (
//             <div className="alert alert-warning text-center">No rooms found.</div>
//           )}
//         </div>
//       </div>

//       {/* 6. ACTIVITIES, REVIEWS, CONTACT */}
//       <div className="mt-5">
//         <Activity />
//         <Services />
//         <BlogPosts />
//        <Testimonials />
//         <ContactSection />
//       </div>
//     </div>
//   );
// }

// //8/7/2026

// import { useEffect, useState } from "react";
// import axios from "axios";
// import HeroAvailability from "../components/HeroAvailability";
// import RoomCard from "../components/RoomCard";
// //import HotelReview from "../components/HotelReview";
// import ContactSection from "../components/ContactSection";
// import './HomePage.css'; // Make sure to create this CSS file!
// import Activity from "../pages/Activity";
// import Services from "../components/Services";
// import BlogPosts from "../components/BlogPosts";
// import Testimonials from "../components/Testimonials";

// export default function HomePage() {
//   const [rooms, setRooms] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [category, setCategory] = useState("all");
//   const [maxPrice, setMaxPrice] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);

//   const roomsPerPage = 6;

//   useEffect(() => {
//     axios
//       .get("http://localhost:8080/api/rooms")
//       .then((res) => setRooms(res.data))
//       .catch((err) => console.error("Error loading rooms:", err));
//   }, []);

//   // FILTERING LOGIC
//   const filteredRooms = rooms.filter((room) => {
//     const matchesSearch =
//       room.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
//       room.description.toLowerCase().includes(searchQuery.toLowerCase());
//     const matchesCategory = category === "all" ? true : room.roomType === category;
//     const matchesPrice = maxPrice === "" ? true : Number(room.price) <= Number(maxPrice);
//     return matchesSearch && matchesCategory && matchesPrice;
//   });

//   const indexOfLastRoom = currentPage * roomsPerPage;
//   const indexOfFirstRoom = indexOfLastRoom - roomsPerPage;
//   const currentRooms = filteredRooms.slice(indexOfFirstRoom, indexOfLastRoom);
//   const totalPages = Math.ceil(filteredRooms.length / roomsPerPage);

//   return (
//     <div className="homepage-wrapper">

//       {/* HERO SECTION */}
//       <div className="hero-fresh d-flex align-items-center justify-content-center">
//         {/* AVAILABILITY FORM COMPONENT */}
//         <HeroAvailability />
//       </div>

//       {/* ABOUT US SECTION */}
//       <section className="container mt-custom-about py-5">
//         <div className="row align-items-center g-5">
//           <div className="col-lg-6">
//             <h6 className="text-roberto text-uppercase fw-bold mb-3">About Us</h6>
//             <h2 className="display-5 fw-bold mb-4">Welcome To <br/>NIVARA AGRO TOURISM</h2>
//             <p className="text-muted leading-relaxed mb-4">
//               <b>Nivara Agro Tourism </b> was born from a simple yet powerful dream — to create a space where the chaos of city life fades away and the soothing rhythm of nature takes over. Nestled along the scenic riverbanks, Nivara Agro Tourism began its journey as a humble retreat for those seeking solace in the arms of nature. What started as a small passion project has blossomed into one of the most sought-after agro tourism destinations in the region.



// Over the years, we have welcomed thousands of guests — families, solo travelers, couples, and corporate groups — all of whom came looking for something real, something raw, and something refreshing. With every passing season, we have grown not just in size but in our commitment to delivering experiences that stay etched in the hearts of our visitors long after they leave.



// Our story is not just about a place — it is about the moments created here, the laughter shared around a bonfire, the thrill of paddling through the river, and the peace found in watching a golden sunrise from a riverside tent. That is the story of Nivara Agro Tourism, and it is still being written — one unforgettable stay at a time.
//             </p>
//             <div className="manager-info">
//                <p className="mb-0">Owner: <span className="text-roberto">Mangesh Dhanawade</span></p>
//                {/* <img src="/signature.png" alt="signature" style={{ width: '120px', opacity: 0.6 }} /> */}
//             </div>
//           </div>
//           <div className="col-lg-6">
//             <div className="row g-3">
//                 <div className="col-8">
//                     <img src="https://images.unsplash.com/photo-1542314831-068cd1dbfeeb" className="img-fluid rounded shadow" alt="hotel1" />
//                 </div>
//                 <div className="col-4">
//                     <img src="https://images.unsplash.com/photo-1566073771259-6a8506099945" className="img-fluid rounded shadow mb-3" alt="hotel2" />
//                     <img src="https://images.unsplash.com/photo-1520250497591-112f2f40a3f4" className="img-fluid rounded shadow" alt="hotel3" />
//                 </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* MAIN CONTENT (ROOMS) */}
//       <div className="container mt-5 pt-5">
//         <div className="text-center mb-5">
//           <h2 className="fw-bold text-success display-6">Explore Our Rooms</h2>
//         </div>

//         {/* SEARCH & FILTERS */}
//         <div className="card shadow-sm p-4 mb-5 border-0 bg-light">
//           <div className="row g-3">
//             <div className="col-md-4">
//               <input type="text" className="form-control" placeholder="Search rooms..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
//             </div>
//             <div className="col-md-4">
//               <select className="form-select" value={category} onChange={(e) => setCategory(e.target.value)}>
//                 <option value="all">All Categories</option>
//                 <option value="AC">AC</option>
//                 <option value="Non-AC">Non-AC</option>
//                 <option value="Deluxe">Deluxe</option>
//                 <option value="Luxury">Luxury</option>
//               </select>
//             </div>
//             <div className="col-md-4">
//               <input type="number" className="form-control" placeholder="Max Price" value={maxPrice} onChange={(e) => setMaxPrice(e.target.value)} />
//             </div>
//           </div>
//         </div>

//         <div className="row">
//           {currentRooms.length > 0 ? (
//             currentRooms.map((room) => <RoomCard key={room.id} room={room} />)
//           ) : (
//             <div className="alert alert-warning text-center">No rooms found.</div>
//           )}
//         </div>

//         {/* PAGINATION */}
//         {totalPages > 1 && (
//           <div className="d-flex justify-content-center gap-2 mt-4">
//             {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
//               <button
//                 key={page}
//                 onClick={() => setCurrentPage(page)}
//                 className={`btn ${currentPage === page ? "btn-success" : "btn-outline-success"}`}
//               >
//                 {page}
//               </button>
//             ))}
//           </div>
//         )}
//       </div>

//       {/* ACTIVITIES, REVIEWS, CONTACT */}
//       <div className="mt-5">
//         <Activity />
//         <Services />
//         <BlogPosts />
//         <Testimonials />
//         <ContactSection />
//       </div>
//     </div>
//   );
// }

//31/7/26


import { useEffect, useState } from "react";
import HeroAvailability from "../components/HeroAvailability";
import RoomCard from "../components/RoomCard";
//import HotelReview from "../components/HotelReview";
import ContactSection from "../components/ContactSection";
import './HomePage.css'; // Make sure to create this CSS file!
import Activity from "../pages/Activity";
import Services from "../components/Services";
import BlogPosts from "../components/BlogPosts";
import Testimonials from "../components/Testimonials";

// 👉 Local rooms data — images loaded from public/images folder
const localRooms = [
  {
    id: 1,
    name: "Deluxe Room",
    roomType: "Deluxe",
    roomNumber: 101,
    capacity: 4,
    price: 1500,
    description: "Spacious deluxe room with river view and modern amenities.",
    image: "/images/room1.jpg",
  },
  {
    id: 2,
    name: "Suite Room",
    roomType: "Luxury",
    roomNumber: 102,
    capacity: 4,
    price: 1500,
    description: "Luxury suite with premium interiors and private balcony.",
    image: "/images/room2.jpg",
  },
  {
    id: 3,
    name: "Family Room",
    roomType: "Family Room",
    roomNumber: 103,
    capacity: 4,
    price: 1500,
    description: "Comfortable family room perfect for groups.",
    image: "/images/room3.jpg",
  },
  {
    id: 4,
    name: "Single Room",
    roomType: "Standard",
    roomNumber: 104,
    capacity: 4,
    price: 1500,
    description: "Cozy Deluxe room, ideal for solo travelers.",
    image: "/images/room4.jpg",
  },
];

export default function HomePage() {
  const [rooms, setRooms] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [category, setCategory] = useState("all");
  const [maxPrice, setMaxPrice] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const roomsPerPage = 6;

  useEffect(() => {
    // Using local room data instead of API call
    setRooms(localRooms);
  }, []);

  // FILTERING LOGIC
  const filteredRooms = rooms.filter((room) => {
    const matchesSearch =
      room.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      room.description.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory = category === "all" ? true : room.roomType === category;
    const matchesPrice = maxPrice === "" ? true : Number(room.price) <= Number(maxPrice);
    return matchesSearch && matchesCategory && matchesPrice;
  });

  const indexOfLastRoom = currentPage * roomsPerPage;
  const indexOfFirstRoom = indexOfLastRoom - roomsPerPage;
  const currentRooms = filteredRooms.slice(indexOfFirstRoom, indexOfLastRoom);
  const totalPages = Math.ceil(filteredRooms.length / roomsPerPage);

  return (
    <div className="homepage-wrapper">
      {/* HERO SECTION */}
      
        
      <div
  className="hero-fresh d-flex align-items-center justify-content-center"
  style={{
    background: `linear-gradient(rgba(28, 195, 178, 0.15), rgba(0, 0, 0, 0.6)), url(${process.env.PUBLIC_URL}/images/mainimage.jpg)`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        


        <HeroAvailability />
      </div>

      {/* ABOUT US SECTION */}
      <section className="container mt-custom-about py-5">
        <div className="row align-items-center g-5">
          <div className="col-lg-6">
            <h6 className="text-roberto text-uppercase fw-bold mb-3">About Us</h6>
            <h2 className="display-5 fw-bold mb-4">Welcome To <br/>NIVARA AGRO TOURISM</h2>
            <p className="text-muted leading-relaxed mb-4">
              <b>Nivara Agro Tourism </b> was born from a simple yet powerful dream — to create a space where the chaos of city life fades away and the soothing rhythm of nature takes over. Nestled along the scenic riverbanks, Nivara Agro Tourism began its journey as a humble retreat for those seeking solace in the arms of nature. What started as a small passion project has blossomed into one of the most sought-after agro tourism destinations in the region.

Over the years, we have welcomed thousands of guests — families, solo travelers, couples, and corporate groups — all of whom came looking for something real, something raw, and something refreshing. With every passing season, we have grown not just in size but in our commitment to delivering experiences that stay etched in the hearts of our visitors long after they leave.

Our story is not just about a place — it is about the moments created here, the laughter shared around a bonfire, the thrill of paddling through the river, and the peace found in watching a golden sunrise from a riverside tent. That is the story of Nivara Agro Tourism, and it is still being written — one unforgettable stay at a time.
            </p>
            <div className="manager-info">
               <p className="mb-0">Owner: <span className="text-roberto">Mangesh Dhanawade</span></p>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="row g-3">
                {/* <div className="col-8">
                    <img src="https://images.unsplash.com/photo-1542314831-068cd1dbfeeb" className="img-fluid rounded shadow" alt="hotel1" />
                </div>
                <div className="col-4">
                    <img src="https://images.unsplash.com/photo-1566073771259-6a8506099945" className="img-fluid rounded shadow mb-3" alt="hotel2" />
                    <img src="https://images.unsplash.com/photo-1520250497591-112f2f40a3f4" className="img-fluid rounded shadow" alt="hotel3" />
                </div> */}


        <div className="col-8">
    <img src="/images/ResortOutside.jpg" className="img-fluid rounded shadow" alt="hotel1" />
</div>
<div className="col-4">
    <img src="/images/kayakingmen.jpg" className="img-fluid rounded shadow mb-3" alt="hotel2" />
    <img src="/images/kayakinggirls.jpg" className="img-fluid rounded shadow" alt="hotel3" />
</div>




            </div>
          </div>
        </div>
      </section>

      {/* MAIN CONTENT (ROOMS) */}
      <div className="container mt-5 pt-5">
        <div className="text-center mb-5">
          <h2 className="fw-bold text-success display-6">Explore Our Rooms</h2>
        </div>

        {/* SEARCH & FILTERS */}
        <div className="card shadow-sm p-4 mb-5 border-0 bg-light">
          <div className="row g-3">
            <div className="col-md-4">
              <input type="text" className="form-control" placeholder="Search rooms..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
            </div>
            <div className="col-md-4">
              <select className="form-select" value={category} onChange={(e) => setCategory(e.target.value)}>
                <option value="all">All Categories</option>
                <option value="AC">AC</option>
                <option value="Non-AC">Non-AC</option>
                <option value="Deluxe">Deluxe</option>
                <option value="Luxury">Luxury</option>
              </select>
            </div>
            <div className="col-md-4">
              <input type="number" className="form-control" placeholder="Max Price" value={maxPrice} onChange={(e) => setMaxPrice(e.target.value)} />
            </div>
          </div>
        </div>

        <div className="row">
          {currentRooms.length > 0 ? (
            currentRooms.map((room) => <RoomCard key={room.id} room={room} />)
          ) : (
            <div className="alert alert-warning text-center">No rooms found.</div>
          )}
        </div>

        {/* PAGINATION */}
        {totalPages > 1 && (
          <div className="d-flex justify-content-center gap-2 mt-4">
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <button
                key={page}
                onClick={() => setCurrentPage(page)}
                className={`btn ${currentPage === page ? "btn-success" : "btn-outline-success"}`}
              >
                {page}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* ACTIVITIES, REVIEWS, CONTACT */}
      <div className="mt-5">
        <Activity />
      
        <Services />
        <BlogPosts />
        <Testimonials />
        <ContactSection />
      </div>
    </div>
  );
}